<template lang="pug">
.container.grid-md
  table.table.table-scroll
    thead
      tr
        th.text-small {{ "doc_planilha.competencia" | tModel }}
        th.text-small {{ "doc_planilha.aliquota" | tModel }}
        th.text-small {{ "doc_planilha.receita_tributavel" | tModel }}
        th.text-small {{ "doc_planilha.iss_devido" | tModel }}
        th.text-small {{ "doc_planilha.iss_recolhido" | tModel }}
        th.text-small {{ "doc_planilha.iss_a_recolher" | tModel }}
        th.text-small {{ "doc_planilha.valor_multa" | tModel }}
        th.text-small {{ "doc_planilha.valor_juros" | tModel }}
        th.text-small {{ "doc_planilha.valor_correcao" | tModel }}
        th.text-small {{ "doc_planilha.valor_penalidade" | tModel }}
        th.text-small {{ "doc_planilha.valor_total" | tModel }}
    tbody
      tr(v-for="planilha in planilhas")
        td.text-small {{ planilha.competencia | date("MM/YYYY") }}
        td.text-small {{ planilha.aliquota | currency("", " %") }}
        td.text-small {{ planilha.receita_tributavel | currency("R$ ") }}
        td.text-small {{ planilha.iss_devido | currency("R$ ") }}
        td.text-small {{ planilha.iss_recolhido | currency("R$ ") }}
        td.text-small {{ planilha.iss_a_recolher | currency("R$ ") }}
        td.text-small {{ planilha.valor_multa | currency("R$ ") }}
        td.text-small {{ planilha.valor_juros | currency("R$ ") }}
        td.text-small {{ planilha.valor_correcao | currency("R$ ") }}
        td.text-small {{ planilha.valor_penalidade | currency("R$ ") }}
        td.text-small {{ planilha.valor_total | currency("R$ ") }}
</template>

<script>
export default {
  props: { planilhas: { type: Array, required: true } },
};
</script>

<style lang="stylus" scoped>
.input-sm {
  max-width: 130px;
}

&.aliquota {
  max-width: 80px;
}
</style>
